import styled from 'styled-components'
// import media from '../../../utils/style'
import { Box } from 'rebass'

const VehicleDetails = styled(Box)`
  color: ${(props) => props.theme.colors.grey};
  h4 {
    & > span {
      display: block;
      float: left;
    }
  }
`

VehicleDetails.displayName = 'VehicleDetails'

export { VehicleDetails }
